export enum ListPageFormTypeEnum {
  Unassisted = 'unassisted',
  Assisted = 'assisted',
}
